<template>
  <div>
    <card-toolbar
      icon="security"
      :title="$tc('password_policy')"
    />

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row class="pa-6">
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="maxInvLogins"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.maxLoginAtempt')"
            :hint="$tc('pwdPolicy.maxInvLogins_reminder')"
            persistent-hint
            append-outer-icon="add"
            @click:append-outer="incrementMaxInvLogins"
            prepend-icon="remove"
            @click:prepend="decrementMaxInvLogins"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="expiration"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.expiration')"
            :hint="$tc('pwdPolicy.expiration_reminder')"
            persistent-hint
            :rules="expirationValidations"
            append-outer-icon="add"
            @click:append-outer="incrementExpiration"
            prepend-icon="remove"
            @click:prepend="decrementExpiration"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="minLen"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.minLen')"
            :rules="minLenValidations"
            append-outer-icon="add"
            @click:append-outer="incrementMinLen"
            prepend-icon="remove"
            @click:prepend="decrementMinLen"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="minSpecial"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.maxSpecial')"
            :hint="$tc('pwdPolicy.password_composition_reminder')"
            :persistent-hint="minSpecial === minSpecialMax"
            :rules="minSpecialValidations"
            append-outer-icon="add"
            @click:append-outer="incrementMinSpecial"
            prepend-icon="remove"
            @click:prepend="decrementMinSpecial"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="minUpper"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.minUpper')"
            :hint="$tc('pwdPolicy.password_composition_reminder')"
            :persistent-hint="minUpper === minUpperMax"
            :rules="minUpperValidations"
            append-outer-icon="add"
            @click:append-outer="incrementMinUpper"
            prepend-icon="remove"
            @click:prepend="decrementMinUpper"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-text-field
            class="text_field"
            v-model="minLower"
            type="number"
            hide-spin-buttons
            :label="$tc('pwdPolicy.minLower')"
            :hint="$tc('pwdPolicy.password_composition_reminder')"
            :persistent-hint="minLower === minLowerMax"
            :rules="minLowerValidations"
            append-outer-icon="add"
            @click:append-outer="incrementMinLower"
            prepend-icon="remove"
            @click:prepend="decrementMinLower"
          />
        </v-col>

        <v-col cols="12">
          <v-row no-gutters justify="end">
            <v-btn color="blue" class="ma-0 mt-3" dark @click="savePolicy">
              {{ $t('save') }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'

export default {
  components: {
    CardToolbar
  },
  data () {
    return {
      minLenValidations: [
        value => { return (!isNaN(value) && value >= 8) || this.$t('min_len_validations.invalid_value') },
        value => { return (value <= 16) || this.$t('min_len_validations.max_value') }
      ],
      minSpecialValidations: [
        value => { return (!isNaN(value) && value >= 0) || this.$t('pwdCompositionValidations.invalid_value') },
        value => { return (value <= this.minSpecialMax) || this.$t('pwdCompositionValidations.max_value') }
      ],
      minUpperValidations: [
        value => { return (!isNaN(value) && value >= 0) || this.$t('pwdCompositionValidations.invalid_value') },
        value => { return (value <= this.minUpperMax) || this.$t('pwdCompositionValidations.max_value') }
      ],
      minLowerValidations: [
        value => { return (!isNaN(value) && value >= 0) || this.$t('pwdCompositionValidations.invalid_value') },
        value => { return (value <= this.minLowerMax) || this.$t('pwdCompositionValidations.max_value') }
      ],
      expirationValidations: [
        value => { return (!isNaN(value) && value >= 0) || this.$t('expirationValidations.invalid_value') },
        value => { return (value <= 255) || this.$t('expirationValidations.max_value') }
      ]
    }
  },
  created () {
    this.$store.dispatch('secPolicy/getPwdSecPolicy')
  },
  beforeDestroy () {
    this.$store.dispatch('secPolicy/getPwdSecPolicy')
  },
  computed: {
    maxInvLogins: {
      get () {
        return this.$store.state.secPolicy.max_inv_logins
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_MAX_INV_LOGINS', int)
      }
    },
    expiration: {
      get () {
        return this.$store.state.secPolicy.expiration
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_EXPIRATION', int)
      }
    },
    minLen: {
      get () {
        return this.$store.state.secPolicy.min_len
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_MIN_LEN', int)
      }
    },
    minLenMin () {
      const min = this.minSpecial + this.minLower + this.minUpper
      return min < 8 ? 8 : min
    },
    minSpecial: {
      get () {
        return this.$store.state.secPolicy.min_special
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_MIN_SPECIAL', int)
      }
    },
    minSpecialMax () {
      return this.minLen - (this.minLower + this.minUpper)
    },
    minUpper: {
      get () {
        return this.$store.state.secPolicy.min_upper
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_MIN_UPPER', int)
      }
    },
    minUpperMax () {
      return this.minLen - (this.minLower + this.minSpecial)
    },
    minLower: {
      get () {
        return this.$store.state.secPolicy.min_lower
      },
      set (val) {
        const int = parseInt(val)
        return this.$store.commit('secPolicy/SET_MIN_LOWER', int)
      }
    },
    minLowerMax () {
      return this.minLen - (this.minUpper + this.minSpecial)
    }
  },
  methods: {
    savePolicy () {
      this.$store.dispatch('secPolicy/setPwdSecPolicy')
        .then(() => this.$notify.success({}))
        .catch(err => {
          if (this.minLen > 16) {
            this.$notify.error({ message: this.$tc('pwdPolicy.min_len_pwd_error') })
          } else if (this.minSpecial > this.minSpecialMax) {
            this.$notify.error({ message: this.$tc('pwdPolicy.max_special_error') })
          } else if (this.minUpper > this.minUpperMax) {
            this.$notify.error({ message: this.$tc('pwdPolicy.max_upper_errors') })
          } else if (this.minLower > this.minLowerMax) {
            this.$notify.error({ message: this.$tc('pwdPolicy.max_lower_errors') })
          } else if (this.expiration > 255) {
            this.$notify.error({ message: this.$tc('pwdPolicy.max_expiration') })
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    incrementMaxInvLogins () {
      this.maxInvLogins = parseInt(this.maxInvLogins, 10) + 1
    },
    decrementMaxInvLogins () {
      if (this.maxInvLogins > 0) {
        this.maxInvLogins = parseInt(this.maxInvLogins, 10) - 1
      }
    },
    incrementMinLen () {
      if (this.minLen < 16) {
        this.minLen = parseInt(this.minLen, 10) + 1
      }
    },
    decrementMinLen () {
      if (this.minLen > this.minLenMin) {
        this.minLen = parseInt(this.minLen, 10) - 1
      }
    },
    incrementMinSpecial () {
      if (this.minSpecial < this.minSpecialMax) {
        this.minSpecial = parseInt(this.minSpecial, 10) + 1
      }
    },
    decrementMinSpecial () {
      if (this.minSpecial > 0) {
        this.minSpecial = parseInt(this.minSpecial, 10) - 1
      }
    },
    incrementMinUpper () {
      if (this.minUpper < this.minUpperMax) {
        this.minUpper = parseInt(this.minUpper, 10) + 1
      }
    },
    decrementMinUpper () {
      if (this.minUpper > 0) {
        this.minUpper = parseInt(this.minUpper, 10) - 1
      }
    },
    incrementMinLower () {
      if (this.minLower < this.minLowerMax) {
        this.minLower = parseInt(this.minLower, 10) + 1
      }
    },
    decrementMinLower () {
      if (this.minLower > 0) {
        this.minLower = parseInt(this.minLower, 10) - 1
      }
    },
    incrementExpiration () {
      if (this.expiration < 255) {
        this.expiration = parseInt(this.expiration, 10) + 1
      }
    },
    decrementExpiration () {
      if (this.expiration > 0) {
        this.expiration = parseInt(this.expiration, 10) - 1
      }
    }
  }
}
</script>

<style lang="scss">
  .text_field{
    width: 260px;

    input{
      text-align: center;
    }
  }

</style>
